import { Component } from '@angular/core';
import { ApiService } from 'src/commonService/apiList/api.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  constructor() {

  }



}
